/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:e4e24eac-d8ae-47af-9f24-c3f3b0f6bbac",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_rJtdppqQ2",
    "aws_user_pools_web_client_id": "799mib9ehr3ockrqa9t2ecslc8",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "contentwriting-20220521122110-hostingbucket-test",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://contentwriting-20220521122110-hostingbucket-test.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
